import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../app.component';
import { ApiService } from '../services/api.service';
import { PermissionsService } from '../services/permissions.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopoverComponent } from '../confirmation-popover/confirmation-popover.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-media-list',
  templateUrl: './media-list.component.html',
  styleUrls: ['./media-list.component.scss']
})
export class MediaListComponent implements OnInit {

  public dataList: any = [];
  public perPage = 20;
  public totalCount = 0;
  public page = 1;
  public from_date = '';
  public to_date = '';
  public category = '';
  public categories = [ 'Bhasma Aarti',
                'Dadyodak Aarti',
                'Bhog Aarti',
                'Sandhya Aarti',
                'Shayan Aarti',
                'General Darshan'];
  public allSelectedCheckBox = false;
  public selectedId = [];

  constructor(
    private apiService: ApiService,
    private appComponent: AppComponent,
    public permissionsService: PermissionsService,
    private modalService: NgbModal,
    private router: Router
  ) { }

  ngOnInit() {
    this.getList();
  }

  getList() {
    this.selectedId = [];
    this.allSelectedCheckBox = false;
    this.appComponent.showLoader();
    
    let url = '/media?';
    if (this.from_date) {
      url += `date=${this.from_date}&`;
    }
    if (this.category) {
      url += `category=${encodeURIComponent(this.category)}&`;
    }
    
    this.apiService.getDataFromServer(url.slice(0, -1)).subscribe(
      (res: any) => {
        this.appComponent.hideLoader();
        this.dataList = res;
        
        // Transform grouped data into flat array for table display
        if (this.dataList && this.dataList.data) {
          const flatData = [];
          Object.keys(this.dataList.data).forEach(category => {
            if (Array.isArray(this.dataList.data[category])) {
              this.dataList.data[category].forEach(item => {
                flatData.push({
                  ...item,
                  checked: false
                });
              });
            }
          });
          this.dataList.data = flatData;
        }
      },
      err => {
        this.appComponent.hideLoader();
        console.log(err);
      }
    );
  }

  onChangeCheckBox(data) {
    this.selectedId = [];
    const isExist = this.dataList.data.find(res => !res.checked);
    if (isExist) {
      this.allSelectedCheckBox = false;
    } else {
      this.allSelectedCheckBox = true;
    }
    this.dataList.data.forEach(res => {
      if (res.checked) {
        this.selectedId.push(res.id);
      }
    });
  }

  onChangeAllCheckBox() {
    this.selectedId = [];
    this.dataList.data.forEach(res => {
      res.checked = this.allSelectedCheckBox;
      if (res.checked) {
        this.selectedId.push(res.id);
      }
    });
  }

  editMedia(data) {
    this.router.navigate(['/edit-media', data.id]);
  }

  deleteMedia(item) {
    const modalRef = this.modalService.open(ConfirmationPopoverComponent,
      {
        centered: false, size: 'sm', windowClass: 'my-class', scrollable: false,
        backdrop: 'static', keyboard: false,
      });
    const deleteComponent: ConfirmationPopoverComponent = modalRef.componentInstance;
    deleteComponent.massage = 'Are you sure you want to delete this media?';
    modalRef.result.then((result) => {
      if (result === 'success') {
        this.appComponent.showLoader();
        this.apiService.deleteDataFromServer(`/media/${item.id}`).subscribe(
          res => {
            this.appComponent.hideLoader();
            this.getList();
            this.appComponent.showMessageAlert('Media deleted successfully', 'success');
          },
          err => {
            this.appComponent.hideLoader();
            this.appComponent.showMessageAlert((err.error && err.error.error && err.error.error[0] && err.error.error[0].message) || 'Error deleting media', 'error');
            console.log(err);
          }
        );
      }
    });
  }

  viewMedia(url) {
    window.open(url, '_blank');
  }

  getMediaTypeIcon(mediaType) {
    return mediaType === 'video' ? 'fa-video-camera' : 'fa-picture-o';
  }

  resetFilters() {
    this.from_date = '';
    this.to_date = '';
    this.category = '';
    this.getList();
  }
}
